import { map } from 'rxjs/operators';
import { SPREADSHEET_API_URL } from 'settings';
import type { IHelperPage } from 'v2/interfaces/helperPage';
import apiService from 'v2/services/api';

/**
 * Service responsible for controlling `HelperPage` component.
 *
 * @class HelperPageService
 */
class HelperPageService {
  /**
   * @method loadHelperPage
   * @return {Observable} an array of `IHelperPage` with the enabled configs on spreadsheet
   * returned by the API
   */
  public loadHelperPage = (page: string) => {
    return apiService
      .get<IHelperPage[]>(`${SPREADSHEET_API_URL}/hints/helps`)
      .pipe(map(helpers => helpers.filter(h => h.enabled && h.label === page)));
  };
}

const HelperPageServiceFactory = new HelperPageService();
export const helperPagesFactory = HelperPageServiceFactory;
